import {useQuery} from 'react-query'
import {PurchasedProductEditModalForm} from './PurchasedProductEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getPurchasedProductById} from '../core/_requests'

const PurchasedProductEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: purchasedproduct,
    error,
  } = useQuery(
    `${QUERIES.USERS_LIST}-purchasedproduct-${itemIdForUpdate}`,
    () => {
      return getPurchasedProductById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )
  if (!itemIdForUpdate) {
    return <PurchasedProductEditModalForm isPurchasedProductLoading={isLoading} purchasedproduct={{id: undefined}} />
  }

  if (!isLoading && !error && purchasedproduct) {
    console.log({purchasedproduct, },"its purchasedproduct")
    console.log(typeof purchasedproduct,"its purchasedproduct")
    return <PurchasedProductEditModalForm isPurchasedProductLoading={isLoading} purchasedproduct={purchasedproduct} />
  }

  return null
}

export {PurchasedProductEditModalFormWrapper}
